/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Agentid1Inputs */

const en_entity_agentid1 = /** @type {(inputs: Entity_Agentid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent ID`)
};

const de_entity_agentid1 = /** @type {(inputs: Entity_Agentid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenten-ID`)
};

/**
* | output |
* | --- |
* | "Agent ID" |
*
* @param {Entity_Agentid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_agentid1 = /** @type {((inputs?: Entity_Agentid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Agentid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_agentid1(inputs)
	return de_entity_agentid1(inputs)
});
export { entity_agentid1 as "entity_agentId" }